import { t } from 'i18next';

import { HouseholdMemberItem } from '@sola/schema/dotcom/children/childUtilityInterfaces.js';

import { templateString } from './bioKeys';

export const getFamilyList = (
  householdMemberList: HouseholdMemberItem[] | null | undefined,
) => {
  const familyArray: string[] = [];
  let sisterCount = 0;
  let brotherCount = 0;

  if (householdMemberList) {
    householdMemberList.forEach((relative) => {
      if (relative.householdMemberRole === 'Sister') {
        sisterCount += 1;
      } else if (relative.householdMemberRole === 'Brother') {
        brotherCount += 1;
      } else if (
        relative.householdMemberRole &&
        relative.householdMemberRole !== 'Beneficiary - Female' &&
        relative.householdMemberRole !== 'Beneficiary - Male' &&
        relative.householdMemberRole !== 'Participant - Female' &&
        relative.householdMemberRole !== 'Participant - Male'
      ) {
        familyArray.push(
          t(templateString('bio:', relative.householdMemberRole)),
        );
      }
    });
  }

  // @TODO: review i18next singular/plural rules with translator. Default KO rules do not match the current Compassion Korea website
  if (sisterCount === 1) {
    familyArray.push(t('bio:sister'));
  }

  if (sisterCount > 1) {
    familyArray.push(t('bio:sisters', { number: sisterCount }));
  }

  if (brotherCount === 1) {
    familyArray.push(t('bio:brother'));
  }

  if (brotherCount > 1) {
    familyArray.push(t('bio:brothers', { number: brotherCount }));
  }

  if (familyArray.length === 0) {
    return t('bio:familySize', {
      context: 'zero',
      firstRelative: t('bio:family'),
    }).toString();
  }

  if (familyArray.length === 1) {
    return t('bio:familySize', {
      context: 'one',
      firstRelative: familyArray[0],
    }).toString();
  }

  if (familyArray.length === 2) {
    return t('bio:familySize', {
      context: 'two',
      firstRelative: familyArray[0],
      lastRelative: familyArray[1],
    }).toString();
  }

  if (familyArray.length >= 3) {
    return t('bio:familySize', {
      context: 'other',
      firstRelative: familyArray[0],
      additionalRelatives: familyArray
        .slice(1, familyArray.length - 1)
        .join(', '),
      lastRelative: familyArray[familyArray.length - 1],
    }).toString();
  }

  return '';
};
